export function getPathnameWithoutLocale(pathname: string): string {
  return pathname.replace(/^\/[a-z]{2}-[A-Z]{2}[^/]*\b/, '');
}

export function buildSearchParamsSuffix(searchParams: Record<string, readonly string[] | string | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(searchParams)) {
    if (typeof value === 'string') {
      params.append(key, value);
      continue;
    }
    for (const item of value ?? []) {
      params.append(key, item);
    }
  }
  const query = params.toString();
  return query ? `?${query}` : '';
}

/**
 * Builds the query suffix used when navigating between problem pages so that 教員 (educator) and
 * レビュアー (reviewer) modes, plus the optional return behavior, carry over across links. Returns an
 * empty string when no value is set so that the suffix can be appended unconditionally.
 */
export function buildNextProblemQuerySuffix({
  isEducator,
  isReview,
  returnTo,
}: {
  isEducator: boolean;
  isReview: boolean;
  returnTo?: 'close';
}): string {
  return buildSearchParamsSuffix({
    educator: isEducator ? 'true' : undefined,
    review: isReview ? 'true' : undefined,
    returnTo,
  });
}
